var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"small"},[_c('line-chart',{staticStyle:{"background":"#19365A","padding":"7px","color":"#fff"},attrs:{"height":300,"dark":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }